import { render, staticRenderFns } from "./memberRule.vue?vue&type=template&id=840cb008&scoped=true&"
import script from "./memberRule.vue?vue&type=script&lang=js&"
export * from "./memberRule.vue?vue&type=script&lang=js&"
import style0 from "./memberRule.vue?vue&type=style&index=0&id=840cb008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840cb008",
  null
  
)

export default component.exports